var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"popup-fade"}},[(_vm.visible)?_c('div',{staticClass:"mobile-popup"},[_c('div',{staticClass:"popup-mask",style:({ backgroundColor: _vm.maskColor }),on:{"click":_vm.handleMaskClick}}),_c('div',{staticClass:"popup-content",style:({ 
        width: '100%', 
        maxHeight: _vm.contentMaxHeight,
        borderRadius: _vm.borderRadius + 'px'
      })},[(_vm.showClose)?_c('div',{staticClass:"popup-close",on:{"click":_vm.handleClose}},[_vm._v("\n        ✕\n      ")]):_vm._e(),_c('div',{staticClass:"popup-body"},[_c('img',{staticClass:"imm",attrs:{"src":_vm.imageSrc,"alt":""}})])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }